module.exports = __webpack_public_path__ + "static/media/inktoberBouquet.bbfe6a53.gif";